<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :updatedItems="updatedItems" :items="items">
        <template slot="title">
          {{ $tc("changeSchedule.title") }}
        </template>
      </Header>
      <v-col class="mt-n5">
        <ChangeTables
          :headers1="headerEmployed"
          :headers2="headerGroup"
          :items1="getEmployedSchedule"
          :items2="getGroupSchedule"
          :title1="title1"
          :title2="title2"
          :seeTables="true"
        />
      </v-col>
      <v-col class="mt-n5">
        <CardDialog
          style="display: flex; justify-content: center; align-content: center"
        >
          <template slot="title">
            <h4 style="color: #39537a; font-weight: lighter !important">
              Complete el formulario
            </h4>
          </template>
          <template slot="body">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              class="mx-2"
              :disabled="signed"
            >
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-select
                required
                :rules="rules"
                :label="$tc('changeSchedule.schedule')"
                dense
                outlined
                v-model="data.schedule"
                :items="getSchedules"
                item-value="scheduleId"
                item-text="name"
                @change="changeSchedule"
              />
              <date class="ml-0 mt-0 mb-6" />

              <v-select
                required
                :rules="rules"
                :label="$tc('changeSchedule.initialSegment')"
                dense
                outlined
                class="mt-5"
                v-model="data.initialSegment"
                :items="getSegment"
                item-value="segmId"
                item-text="segment"
                @change="changeSegment"
                :no-data-text="$tc('changeSchedule.noSegment')"
              />
              <v-select
                required
                :rules="rules"
                :label="$tc('changeSchedule.initialDay')"
                dense
                outlined
                v-model="data.initialDay"
                :items="initialDay"
                :no-data-text="$tc('changeSchedule.noSequence')"
              />
              <v-select
                required
                :rules="rules"
                :label="$tc('changeSchedule.sequenceNumber')"
                dense
                outlined
                :items="getNumSequence"
                item-value="id"
                item-text="id"
                :no-data-text="$tc('changeSchedule.noSequence')"
                v-model="data.sequenceNumber"
              />
            </v-form>
            <div class="d-flex justify-space-between mx-2">
              <v-btn class="bt-exit" @click="cancel()" :disabled="signed"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                @click.prevent="validate"
                :disabled="signed"
              >
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </template>
        </CardDialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import CardDialog from "./common/CardDialog.vue";
import DataTable from "./common/DataTable.vue";
import ChangeTables from "./common/ChangeTables.vue";
import Date from "./common/DateRegis.vue";

export default {
  components: { Header, CardDialog, DataTable, ChangeTables, Date },
  props: {
    items: Object,
    refreshForm: Number,
  },
  data() {
    return {
      updatedItems: [],
      title1: this.$tc("changeSchedule.assignedEmployed"),
      title2: this.$tc("changeSchedule.assignedGroups"),
      counter: 0,
      data: {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        schedule: null,
        initialSegment: null,
        initialDay: null,
        sequenceNumber: null,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
      },
      fromMenuDate: false,
      toMenuDate: false,
      initialDay: null,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      valid: true,
      error: false,
      alertValidate: "",
      checkTo: this.$store.state.gestionTiempos.checkTo,
      alertError: false,
      alertOk: false,
      textAlert: "",
      renderComponent: true,
      headerEmployed: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
      ],
      headerGroup: [
        {
          text: "Grupo",
          value: "group",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Horario",
          value: "schedule",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
      ],
    };
  },

  watch: {
    refreshForm(newValue, oldValue) {
      if (newValue > oldValue) {
        this.$refs.form.resetValidation();
        this.data = {
          from: this.$store.state.gestionTiempos.dateFromComponents,
          to: this.$store.state.gestionTiempos.dateToComponents,
          schedule: null,
          initialSegment: null,
          initialDay: null,
          sequenceNumber: null,
          date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        };
      }
    },
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getSchedules() {
      return this.$store.state.changeSchedule.schedule;
    },
    getSegment() {
      return this.$store.state.changeSchedule.segment;
    },
    getNumSequence() {
      return this.$store.state.changeSchedule.numsequence;
    },
    getChangeSchedule() {
      return this.$store.state.changeSchedule.changeSchedule[0].from;
    },
    getEmployedSchedule() {
      return this.$store.state.changeSchedule.employedSchedule;
    },
    getGroupSchedule() {
      return this.$store.state.changeSchedule.groupSchedule;
    },
  },

  methods: {
    //cambia el select del horario
    changeSchedule() {
      this.$store.commit("changeSchedule/setScheduleId", this.data.schedule);
      this.$store.dispatch("changeSchedule/getSegment");
    },
    //cambia el select del segmento
    changeSegment() {
      this.$store.commit("changeSchedule/setScheduleId", this.data.schedule);
      this.$store.commit("changeSchedule/setSegmId", this.data.initialSegment);
      this.$store.dispatch("changeSchedule/getSequence").then(() => {
        this.initialDay = this.inicialDay();
      });
    },
    //dia de incio
    inicialDay() {
      let inicialDay = this.$store.state.changeSchedule.segment.filter(
        (option) => {
          return option.segmId == this.data.initialSegment;
        }
      );
      let numberOfDays = inicialDay[0].days;
      let element = [];
      for (let array = 1; array <= numberOfDays; array++) {
        element.push(array);
      }

      return element;
    },

    validate() {
      if (this.$store.state.gestionTiempos.checkTo) {
        this.$store.commit("gestionTiempos/setDateToComponents", null);
        this.data.to = null;
      }
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.from > this.data.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.addChangeSchedule();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    //se crea un nuevo horario
    addChangeSchedule() {
      let payload = {
        date: this.data.date,
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        initialDay: this.data.initialDay,
        initialSegment: this.data.initialSegment,
        schedule: this.data.schedule,
        sequenceNumber: this.data.sequenceNumber,
      };
      this.$store.commit("changeSchedule/setNew", payload);
      this.$store
        .dispatch("changeSchedule/getChangeSchedule")
        .then((r) => {
          this.textAlert = this.$tc("changeSchedule.alertChange");
          this.alertOk = true;

          this.counter++;

          const name = this.$store.state.changeSchedule.schedule.find(
            (item) => {
              return item.scheduleId === payload.schedule;
            }
          ).name;

          this.updatedItems = this.updatedItems.filter(
            (item, i) => item.empId !== this.items.empId
          );

          this.updatedItems.push({
            empId: this.items.empId,
            name,
          });

          this.reset();
          this.$store.dispatch("changeSchedule/getEmployedSchedule");
          this.$store.dispatch("changeSchedule/getGroupSchedule");
          setTimeout(() => {
            this.$emit("close");
          }, 2500);
        })
        .catch((e) => {
          console.log(e);
          this.alertError = true;
          this.textAlert = this.$tc("changeSchedule.alertChangeError");
          this.reset();
        });
    },
    cancel() {
      this.error = false;
      this.reset();
      this.$emit("close");
    },
    reset() {
      this.$refs.form.resetValidation();
      this.checkTo = false;
      const today = this.items.date
        .slice(0, 10)
        .split(/\D/)
        .reverse()
        .join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", today);
      this.$store.commit("gestionTiempos/setDateToComponents", today);
      this.$store.commit("gestionTiempos/setCheckTo", this.checkTo);
      this.data = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        schedule: null,
        initialSegment: null,
        initialDay: null,
        sequenceNumber: null,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
      };
    },
  },
};
</script>

<style scoped>
.card {
  display: flex !important;
  justify-content: center !important;
  border-radius: 50px !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

@media (min-width: 482px) and (max-width: 550px) {
  .v-form {
    max-width: 400px !important;
  }
}

@media (min-width: 300px) and (max-width: 482px) {
  .v-form {
    max-width: 300px !important;
  }
}
.btn__change {
  display: flex !important;
  justify-content: center !important;
  /* margin-right:100px !important */
}
</style>
